export default __webpack_public_path__ + "static/media/Statistic_2011_2012_SUB.0aad70e0.pdf";